<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex "style="min-height: 600px; background-image: url(img/brand/ujia.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex ">
                <div class="row">
                    <div class="col-sm-6">
                        <h1 class="display-2 text-white">Jadwal Worksheet</h1>
                    </div>
                    <div class="col-sm-6">
                        <button @click="getListWorksheet()" class="btn float-right btn-sm mt-3 p-2 btn-rounded btn-info">Refresh</button>
                    </div>
                    <div class="col-lg-12">

                        <p class="text-white mt-0 mb-0" style="opacity: 0;">This is your profile page. You can see the progress you've made with your work and manage your projects or assigned tasks</p>
                        <div class="alert alert-secondary" v-for="lu in list_ujian" @click="detailWorksheet(lu.id_worksheet_siswa)">
                            <div class="row">
                                <div class="col-sm-8">              
                                    <b style="color: #ff9d64;font-size: 20px">{{ lu.no_soal_ujian }}</b>
                                </div>
                                <div class="col-sm-4">
                                    <a v-if="lu.kinerja!=null" @click="kinerja(lu.kinerja.id_jadwal)" class="btn text-white btn-primary float-right" style="margin-top:-7px;">Lihat Hasil</a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> </base-header>
            <div id="overlay" v-if="showModal" >
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h3 class="modal-title" style="font-size: 20px" >Konfirmasi Data Peserta</h3>
                            <button type="button" @click="showModal=false" class="close">
                                <span style="color: #ff9d64;font-size: 20px" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body" >
                            <form action="#" style="height: 400px;overflow-y: scroll; padding-bottom:100px;">
                                <div>
                                    <div class="form-group" style="border-bottom: 1px solid #00000036;padding: 0px;">
                                        <label style="font-weight: bold" for="">Kode Soal</label>
                                        <p style="margin-bottom: 0px;">{{ this.currUjian.bank_soal.no_soal_ujian }}</p>
                                    </div>
                            <!-- <div class="form-group" style="border-bottom: 1px solid #00000036;padding: 0px;">
                                <label style="font-weight: bold" for="">Jumlah Soal</label>
                                <p style="margin-bottom: 0px;">{{ this.currUjian.get_worksheet.jumlah_soal }}</p>
                            </div> -->
                            <div class="form-group" style="border-bottom: 1px solid #00000036;padding: 0px;">
                                <label style="font-weight: bold" for="">Durasi</label>
                                <p style="margin-bottom: 0px;">{{ this.currUjian.get_worksheet.durasi }} Menit</p>
                            </div>
                            <div class="form-group" style="border-bottom: 1px solid #00000036;padding: 0px;">
                                <label style="font-weight: bold" for="">Peserta</label>
                                <p style="margin-bottom: 0px;">{{ this.$session.get('nama')+" "+this.$session.get('nis') }}</p>
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <button class="btn btn-info" @click="cekPassword">Konfirmasi & Mulai Ujian</button>
                            <button class="btn btn-warning" @click="showModal=false">Batal</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: 'user-profile',
    data() {
        return {
            list_ujian:[],
            showModal:false,
            password : '',
            id_ujian: '',
            currUjian : ''
        }
    },
    mounted(){
        // this.getListUjian()
        this.checkFeedback()
        this.getListWorksheet()
    },
    methods:{
        checkFeedback(){
            var post = axios.get(this.$assets_url+"check-feedback/"+this.$session.get('id_siswa').toString())
            post.then((res)=>{
                var udah = res.data;
                if (udah==false) {
                    this.$toast.warning("Mohon isi feedback terlebih dahulu sebelum melanjutkan", 'Oops', {position:'topRight'})
                    this.$router.push('feedback/cabang')
                }
            }).catch(e => {
              console.log(e)
          });
        },
        getListUjian()
        {
            var id_kelas = this.$session.get('id_kelas');

            var post = axios.get(this.$api_url+"get-ujian/"+id_kelas+'/'+this.$session.get('id_siswa'))
            post.then((res)=>{
                var data = res.data[0];
                if (data.error) {
                    this.$toast.warning(data.message, 'Oops', {position:'topRight'})
                }else{
                    this.list_ujian = data.data
                }
            }).catch(e => {
                console.log(e)
            });
        },
        getListWorksheet()
        {
            var id_kelas = this.$session.get('id_kelas');

            var post = axios.get(this.$assets_url+"api/v1/get-worksheet"+'/'+this.$session.get('id_siswa'))
            post.then((res)=>{
                // console.log(this.$session.get('id_siswa'))
                this.list_ujian = res.data
            }).catch(e => {
                console.log(e)
            });
        },

        detailWorksheet(id){
            var post = axios.get(this.$assets_url+"api/v1/get-worksheet-detail"+'/'+id)
            post.then((res)=>{
                console.log(res);
                if (res.data.kinerja==null) {
                    this.currUjian = res.data
                    this.showModal = true
                    this.id_ujian = id;
                }else{
                    this.$toast.warning("Kamu sudah mengerjakan worksheet ini sebelumnya", 'Oops', {position:'topRight'})
                }
            }).catch(e => {
                console.log(e)
            });
        },
        openUjian(i){
            this.showModal = true;
            this.id_ujian = i;
            var post = axios.get(this.$assets_url+"/api/v1/get-detail-ujian/"+i)
            post.then((res)=>{
                var data = res.data[0];
                this.currUjian = data.data
            }).catch(e => {
                console.log(e)
            });
        },
        cekPassword(){
            var id_ujian = this.id_ujian;
            // console.log(this.currUjian.get_worksheet.durasi)
            var data_ujian = {
                'id_ujian'  : id_ujian,
                'durasi'  : this.currUjian.get_worksheet.durasi,
                'durasi_'  : this.currUjian.get_worksheet.durasi,
                'keterangan' : "",
                'tampil_hasil':this.currUjian.tampil_hasil
            }
            // console.log(data_ujian)
            this.$cookies.set('data_ujian',data_ujian);
            this.$router.push('ujian')
        },
        kinerja(id){
            window.open(this.$assets_url+"detail-kinerja/"+id,'__blank');
        }
    }
};
</script>
<style >
.alert-secondary{
    cursor: pointer;
    transition: all 0.3s;
}
.alert-secondary:hover{
    margin-top: -10px;

    box-shadow: 3px 3px 10px #8de7c2;
}
#overlay{
    transition: all 0.3s;
    position: fixed;
    top: 0;
    padding-top: 40px;
    right: 0;
    left: 0;
    height: 100%;
    z-index: 9999;
    background: rgba(0,0,0,0.4);
}
</style>
